import React, { ForwardedRef, forwardRef } from "react";
import cx from "components/src/utils/cx";
import { type MarketButtonDataQaType, type MarketButtonRoundedType } from "../types";

const roundedClasses = {
  sm: "cui-rounded-sm",
  md: "cui-rounded-md",
  lg: "cui-rounded-lg"
};

export const MarketButtonWrapper = forwardRef(({
    children,
    variant,
    isEnabled,
    className,
    hasDescription,
    fluid = false,
    fullHeight = false,
    rounded,
    dataQa,
    filterGroup
  }: {
    children: React.ReactNode;
    variant: string;
    isEnabled: boolean;
    className?: string | undefined;
    hasDescription: boolean;
    fluid?: boolean;
    fullHeight?: boolean;
    rounded?: MarketButtonRoundedType;
    dataQa?: MarketButtonDataQaType;
    filterGroup?: string;
  }, wrapperRef: ForwardedRef<HTMLDivElement>) => {
    const [isLarge, isFixed] = [variant === "large", variant === "fixed" || variant === "highlight"];
    const roundedClass = rounded ? roundedClasses[rounded] : "cui-rounded-[2px]";
    return (
      <div
        className={cx(
          {
            "cui-w-[154px]": isLarge && !fluid,
            "cui-h-auto cui-min-h-[142px]": isLarge && !fullHeight,
            "cui-h-[44px]": !isLarge && !fullHeight,
            "cui-h-full": fullHeight,
            "cui-w-[60px] sbk-tablet:cui-w-[114px] sbk-desktop:cui-w-full sbk-desktop:cui-max-w-[264px]":
              isFixed && !fluid && !hasDescription,
            "cui-w-full": variant === "fluid" || fluid || hasDescription,
            "cui-pointer-events-none": !isEnabled,
            [className ? className : '']: true
          },
          `cui__market-button-wrapper [&_*]:cui-box-border cui-relative ${roundedClass} cui-group`
        )}
        data-qa={dataQa?.marketButtonWrapper}
        {...(filterGroup !== undefined && { "data-filter-group": filterGroup })}
        ref={wrapperRef}
      >
        {children}
      </div>
    );
  });

  export default MarketButtonWrapper
  